import $ from './lib/jquery';
import "magnific-popup";
// import 'slick-carousel';
// import TraversableMenu from 'traversable_menu';
import TraversableMenu from './lib/traversable_menu/traversable_menu';
// import Swiper, { Navigation, Pagination } from 'swiper';
import'bootstrap/dist/js/bootstrap.bundle';
import Swiper from 'swiper/swiper-bundle';
import 'magnific-popup/dist/jquery.magnific-popup';
import 'lazySizes';
import 'parsleyjs';
import 'jquery-focuspoint/js/jquery.focuspoint';


$( document ).ready(function() {
    /**
     * Name           : Navigation
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */

    $('.hamburger, .navi-button').on('click', function () {
        $('.sidebar').toggleClass('opened');
        $('[data-main]').toggleClass('hasVisibleSidebar');
        $('html').toggleClass('noscroll');
    });

//Close menu if click outside of navbar
    $(window).click(function () {
        $('.sidebar').removeClass('opened');
        $('[data-main]').removeClass('hasVisibleSidebar');
        $('html').removeClass('noscroll');
    });
    $('.navbar-toggler, .sidebar').click(function (event) {
        event.stopPropagation();
    });

    var traversable = new TraversableMenu(
        {
            //'panel_title_first': 'Traversable Menu Example'
            // many additional options here; see below
            triggers: {
                'parent_text': 'Zu [:previous-title:]',
                'top_text': 'Zum Hauptmenü',
            },
            accessibility: {
                'container_role': 'navigation',
                'panel_role': 'group',
            },
            'panel_title_link_enabled': true,
        }
    );





    /**
     * Name           : Tab-Carousel
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : slick: https://kenwheeler.github.io/slick/, jQuery
     */
    // $('.tab-carousel').slick({
    //     accessibility: true,
    //     centerMode: true,
    //     centerPadding: '20px',
    //     cssEase: 'ease',
    //     // focusOnSelect: true,
    //     infinite: true,
    //     slidesToShow: 3,
    //     speed: 500,
    //     variableWidth: true,
    // });
    // $('.tab-carousel').slick('slickSetOption', 'lidesToScroll', 3, true);

    const swiper = new Swiper('.tab-carousel', {
            // Optional parameters
            loop: false,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1.66,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2.4,
                    spaceBetween: 30
                },
                // when window width is >= 720px
                720: {
                    slidesPerView: 3.5,
                    spaceBetween: 40
                }
            },
            // If we need pagination
            // pagination: {
            //     el: '.swiper-pagination',
            //     type: "fraction",
            // },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });

    /* Gallery */
    const gallery = new Swiper('.gallery', {
        // Optional parameters
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 30,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            type: "fraction",
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });

    /* Stage-Gallery */
    const stagegallery = new Swiper('.stage-gallery', {
        // Optional parameters
        loop: true,
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,
        slidesPerView: '1',
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        // navigation: {
        //     nextEl: '.swiper-next',
        //     prevEl: '.swiper-prev',
        // },
    });
    $(".swiper-button-pause").click(function(){
        stagegallery.autoplay.stop();
        $('.stage-gallery').toggleClass('paused')
    });

    $(".swiper-button-play").click(function(){
        stagegallery.autoplay.start();
        $('.stage-gallery').toggleClass('paused')
    });




    /**
     * Name           : Magnific-Popup
     * Beschreibung   : Magnific Popup is a responsive lightbox & dialog script with focus on performance and providing best experience for user with any device
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://dimsemenov.com/plugins/magnific-popup/
     */
    $('.popup-with-form').magnificPopup({
        alignTop: true,
        type: 'inline',
        preloader: false,
        focus: '#autocomplete',
        closeBtnInside: false,
        showCloseBtn: false,

        // When elemened is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#autocomplete';
                }
            }
        }
    });

    $('body').on('click','.mfp-content .close-button', function(){
        $.magnificPopup.close();
    });






    /**
     * Name           : MagnificPopup
     * Beschreibung   : PopUps und Lightbox für Artikelbilder, Hinweise und Formulare
     * Parameter      : Klasse des Elements
     * Rückgabe       : -
     * Bibliothek     : jQuery, Magnific Popup (magnific_min.js)
     */
    var groups = {};
    $('.mfp').each(function() {
        var id = parseInt($(this).attr('data-group'), 10);

        if(!groups[id]) {
            groups[id] = [];
        }

        groups[id].push( this );
    });

    $.each(groups, function() {

        $(this).magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            gallery: {
                enabled:true,
                tCounter: '<span class="mfp-counter">%curr% von %total%</span>' // markup of counter
            }
        })

    });




    /**
     * Name           : jQuery focuspoint
     * Beschreibung   : FocusPoint 2
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://github.com/jonom/jquery-focuspoint
     */
    $('.focuspoint').focusPoint();




    /**
     * Name           : Autocomplete
     * Beschreibung   : Autocomplete/Autosuggest für Suche
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    if ( $('#autocomplete').length){

        /*Variables*/
        var searchfields = $('#autocomplete');
        var searchOverlay = $('.suggest-overlay');
        var searchlayerEntries= $('.searchlayer-entries');
        var $list = $('.autocomplete-list');
        var $listDetail = $( ".autocomplete-details" );
        var searchterm;
        var getSlug = require('speakingurl');

        /*Focus Search*/
        searchfields.click(function() {
            $(this).addClass('focus');
            searchOverlay.addClass('open');
            searchlayerEntries.show();
        });

        searchfields.bind('keydown', function(e){
            var input = $(this).val();
            if (input.length >= 2) {
                const firstIndex = $('.autocomplete-list').find('li').first().index();
                const lastIndex = $('.autocomplete-list').find('li').last().index();

                    var index = $('.autocomplete-list').find('.active').index();

                    switch (e.which) {
                        case 38://up
                            index = (index == firstIndex ? -1 : index - 1);
                            browseNavigation();
                            resetInputField(); //to keep cursor at the end of input-field
                            break;
                        case 40://down
                            index = (index == lastIndex ? -1 : index + 1);
                            browseNavigation();
                            break;
                        case 13://enter
                            if(index == -1) {
                             //focus on input-fiels --> go to searchresult page
                            }
                            else {
                                e.preventDefault();
                                var url = $('.autocomplete-list').find('.active a').attr('href');
                                // console.log(url);
                                window.open(url, '_self');
                            }
                            break;
                        default:
                            startSearch(input);
                            searchlayerEntries.show();
                    }
                    // console.log(index);
                    function browseNavigation() {
                        $('.autocomplete-list').find('.active').removeClass('active');
                        if (index == -1) {
                            resetInputField();
                        }
                        else {
                            $('.autocomplete-list').find('li:eq( ' + index + ' )').addClass('active').focus();
                            var $itemPreviewUrl = $('.autocomplete-list').find('.menu-item:eq( ' + index + ' )').addClass('active').find('a').attr('href') + '?template=d_aan_search_preview';
                            $listDetail.load($itemPreviewUrl);
                        }
                    }

            }
        });

        function resetInputField() {
            //Move Cursor to end of input-field
            var val = $('#autocomplete').val();
            setTimeout(function() {
                $('#autocomplete').val('');
                $('#autocomplete').val(val); //set value back.
            },5);
        }

        // function searchInput(input) {
        //     startSearch(input);
        //     searchlayerEntries.show();
        // }

        function startSearch(searchText) {
            $listDetail.empty();
            return new Promise(function(resolve, reject) {
                $.ajax({
                    // url: "https://www.stadtbibliothek-rottenburg.de/api/LibSuggestApi.php",
                    url: "https://www.aalen.de/api/SuggestApiNew.php",
                    dataType: "json",
                    data: {
                        search: searchText
                    },
                    success: function (data) {
                        searchterm = searchText;
                        var response = data;
                        $(".autosuggest-hits").show();
                        // clear list and detail
                        $list.html('');

                        response.forEach(function (item) {
                            var $listItem = $('<li class="menu-item" />');
                            var $itemUrl = '/' + getSlug(item.title) + '.' + item.id + '.htm';
                            var $itemLink = $('<a class="menu-item-wrapper" />').attr('href', $itemUrl);
                            var $itemArea = $('<span class="area"/>').text(item.area);
                            var $itemText = $('<span/>').text(item.title);
                            //var $itemPreviewUrl = "/sixcms/detail.php?id=" + item.id + '&template=d_aan_search_preview';
                            var $itemPreviewUrl = "https://www.aalen.de/sixcms/detail.php?id=" + item.id + '&template=d_aan_search_preview';
                            $itemLink.append($itemArea);
                            $itemLink.append($itemText);
                            //focus via mouseover
                            $itemLink.mouseenter(function () {
                                $list.find('.active').removeClass('active');
                                $listItem.addClass('active');
                                $listDetail.load($itemPreviewUrl);
                            });
                            //focus via tab
                            $itemLink.focus(function () {
                                $list.find('.active').removeClass('active');
                                $listDetail.load($itemPreviewUrl);
                            });
                            $listItem.append($itemLink).appendTo($list);

                        });

                        //See all results
                        // console.log("change list");
                        $('.autocomplete-list').append('<li class=\"all-results-link\"><a class=\"trigger-submit\" href=\"' + $('#autocompleteform').attr('action') + '?search=' + searchterm + '\" target=\"_blank\">Alle Suchergebnisse</a></li>');
                        $('.autocomplete-list .trigger-submit').click(function (e) {
                            $('.searchlayer .search').submit();
                        });

                        // Load preview on hover
                        // $list.children().hover(function(item) {
                        //     $listDetail.load($item.preview);
                        // });

                        //No Results
                        // if ($.trim(response) == '' ) {
                        //     $('.autocomplete-list').append('<li>Keine Ergebnisse im Titel gefunden. <a href="https://www.aalen.de/suche.124977.htm?search=' + searchText + '">Suche im Volltext fortsetzen.</a></li>');
                        //     return;
                        // }
                        // console.log("list updated...");
                        resolve(data);
                    },
                    error: function(error) {
                        reject(error);
                    }
                });
            });
        }

        if($('.autocomplete-list li a:focus').length)    {
            alert("focus with tab");
        }
    }

    if ( $('.searchresult-hits').length) {
        var hits = $('.searchresultlist').data("searchhits");
        $('.hits').text(hits);
    }





    /**
     * Name           : Parsley Validation
     * Beschreibung   : add bootstrap wrapper to tables, which are added via tinymce
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : jQuery
     */
    $('.formgenerator').parsley({
        errorsWrapper: '<div class="error"></div>',
        errorTemplate: '<div class="parsley-error"></div>',
        trigger: 'blur'
    });




    /**
     * Name           : Tooltip
     * Beschreibung   : Tooltip for i-Button within forms
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : Bootstrap
     */
     $("[data-bs-toggle=\"tooltip\"]").tooltip();


});